<template>
  <v-card>
    <v-form @submit.prevent="declaredChallengePerformance" v-model="valid">
      <v-card-title>{{
        endEventMode
          ? $t("participant.live.challengePerformance.popup.endEvent.title")
          : $t("participant.live.challengePerformance.popup.title")
      }}</v-card-title>
      <v-card-text>
        <p>
          {{
            endEventMode
              ? $t("participant.live.challengePerformance.popup.endEvent.intro")
              : $t("participant.live.challengePerformance.popup.intro")
          }}
        </p>
        <v-text-field
          v-if="!isRunningActivity"
          :label="$t('participant.live.challengePerformance.popup.field')"
          :rules="[$v.required()]"
          name="challengePerformanceResult"
          ref="challengePerformanceResult"
          required
          v-model="challengePerformanceResult"
          :hint="$t('participant.live.challengePerformance.popup.hint')"
        ></v-text-field>
        <v-text-field
          v-else
          ref="challengePerformanceResult"
          v-model="runningMetersResult"
          :label="$t('participant.live.challengePerformance.popup.meters')"
          :rules="[$v.required()]"
          name="challengePerformanceResult"
          required
          type="number"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          text
          @click="
            continueClick();
            cancel();
          "
          >{{ $t("participant.live.challengePerformance.popup.skip") }}</v-btn
        >

        <v-btn :disabled="!valid" color="primary" type="submit">{{
          $t("participant.live.challengePerformance.popup.save")
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "ParticipantChallengePerformance",
  data() {
    return {
      runningMetersResult: Math.round(this.$store.state.geolocation.distance),
      challengePerformanceResult: this.$store.state.geolocation.distance
        ? this.$t("participant.live.challengePerformance.popup.defaultPerformance", [
            Math.round(this.$store.state.geolocation.distance),
          ])
        : "",
      valid: false,
    };
  },
  computed: {
    isRunningActivity() {
      return this.$store.state.selectedActivity.isRunning === true;
    },
  },
  props: {
    endEventMode: Boolean,
  },
  methods: {
    async declaredChallengePerformance() {
      if (!this.valid) return;

      if (this.isRunningActivity) {
        await this.$store.commit("DISTANCE_SET", this.runningMetersResult);
      } else {
        await axios.post(
          `/event/activities/session/${this.$store.state.sessionId}/participant/${this.$store.state.participantId}/declareChallengePerformance`,
          {
            declaredChallengePerformance: this.challengePerformanceResult,
          }
        );
        this.$store.commit("CHALLENGE_PERFORMANCE", this.challengePerformanceResult);
      }

      window.sessionStorage.setItem("challengeDeclared_" + this.$route.params["activity_slug"], "true");

      this.continueClick();
    },
    continueClick() {
      this.$store.commit("TRACKING_ENABLED", false);
      this.$emit("continue");
    },
    cancel() {
      this.$emit("cancelPerformance");
    },
  },
};
</script>

<style scoped></style>
